import { useState, useEffect } from 'react';
import { FiDownload, FiMail, FiX, FiEdit2 } from 'react-icons/fi';
import { StatusBadge, EmptyState } from '../../components/common';
import { DOCUMENT_STATUS } from '../../constants/statusMaps';
import { TABLE, ACTIONS } from '../../constants/labels';
import { fmtCurrency } from '../../utils/formatNumber';
import { formatDate } from '../../utils/dateUtils';
import { EXPENSES_LABEL } from './paymentsConfig';
import styles from './Payments.module.css';

const PAGE_SIZE = 50;

export default function PaymentsTable({ vouchers, totalAmount, onDownload, onEmail, onCancelClick, onEditClick, canManage = true }) {
  const [page, setPage] = useState(0);
  useEffect(() => { setPage(0); }, [vouchers]);
  const totalPages = Math.ceil(vouchers.length / PAGE_SIZE);
  const visibleVouchers = vouchers.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

  return (
    <>
    <div className="card">
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th style={{ width: 40 }}>#</th>
              <th>{TABLE.voucherNo}</th>
              <th>{TABLE.date}</th>
              <th>Debit Account</th>
              <th>Credit Account</th>
              <th>{TABLE.category}</th>
              <th>Expense Type</th>
              <th>Payee</th>
              <th>Mode</th>
              <th className={styles.amtRight}>{TABLE.amount}</th>
              <th>{TABLE.actions}</th>
            </tr>
          </thead>
          <tbody>
            {vouchers.length === 0 && (
              <tr>
                <td colSpan={11}>
                  <EmptyState message={TABLE.noResults(EXPENSES_LABEL)} />
                </td>
              </tr>
            )}
            {visibleVouchers.map((v, idx) => (
              <tr key={v.id}>
                <td>{page * PAGE_SIZE + idx + 1}</td>
                <td><code>{v.voucherNo}</code></td>
                <td>{formatDate(v.voucherDate)}</td>
                <td>{v.debitAccount?.name || '—'}</td>
                <td>{v.creditAccount?.name || '—'}</td>
                <td>{v.DonationCategory?.name || '—'}</td>
                <td>{v.ExpenseType?.name || '—'}</td>
                <td>{v.payeeName || '—'}</td>
                <td>{v.paymentMode?.replace(/_/g, ' ') || '—'}</td>
                <td className={styles.amtRight}>{fmtCurrency(v.amount)}</td>
                <td>
                  <div className={styles.actions}>
                    <button className="btn btn-ghost btn-sm" title={ACTIONS.download} onClick={() => onDownload(v)}>
                      <FiDownload />
                    </button>
                    {!v.isCancelled && (
                      <button className="btn btn-ghost btn-sm" title={ACTIONS.email} onClick={() => onEmail(v)}>
                        <FiMail />
                      </button>
                    )}
                    {!v.isCancelled && canManage && (
                      <button className="btn btn-ghost btn-sm" title="Edit" onClick={() => onEditClick(v)}>
                        <FiEdit2 />
                      </button>
                    )}
                    {!v.isCancelled && canManage && (
                      <button className="btn btn-danger btn-sm" title={ACTIONS.cancel} onClick={() => onCancelClick(v)}>
                        <FiX />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
          {vouchers.length > 0 && (
            <tfoot>
              <tr>
                <td colSpan={9}><strong>{TABLE.totals}</strong></td>
                <td className={styles.amtRight}><strong>{fmtCurrency(totalAmount)}</strong></td>
                <td colSpan={1} />
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
      {totalPages > 1 && (
        <div className={styles.paginationBar}>
          <button className="btn btn-ghost btn-sm" onClick={() => setPage((p) => p - 1)} disabled={page === 0}>← Prev</button>
          <span>Page {page + 1} of {totalPages} &nbsp;·&nbsp; {vouchers.length} total</span>
          <button className="btn btn-ghost btn-sm" onClick={() => setPage((p) => p + 1)} disabled={page >= totalPages - 1}>Next →</button>
        </div>
      )}
    </>
  );
}
